import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { Checkbox } from '@applyboard/ui-components';
import { RequirementCard } from "./RequirementCard";
import { RequirementRow } from "./style";
var SelectableRequirementRow = function SelectableRequirementRow(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    currentStage = _ref.currentStage,
    finalStage = _ref.finalStage,
    category = _ref.category,
    entityLevel = _ref.entityLevel,
    status = _ref.status,
    tags = _ref.tags,
    checked = _ref.checked,
    _onChange = _ref.onChange,
    isEarlyAccess = _ref.isEarlyAccess;
  return /*#__PURE__*/React.createElement(RequirementRow, null, /*#__PURE__*/React.createElement(Checkbox, {
    id: "".concat(id, "-checkbox"),
    checked: checked,
    onChange: function onChange(event) {
      _onChange(event, id);
    },
    inputProps: {
      'aria-label': "Requirement ".concat(title)
    }
  }), /*#__PURE__*/React.createElement(RequirementCard, {
    id: id,
    title: title,
    description: description,
    currentStage: currentStage,
    finalStage: finalStage,
    category: category,
    entityLevel: entityLevel,
    status: status,
    tags: tags,
    isEarlyAccess: isEarlyAccess
  }));
};
export default /*#__PURE__*/React.memo(SelectableRequirementRow);